





























































import $ from 'jquery'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Util, { ItemlistUrlQueryParameter } from '../../../modules/util'
import BootstrapDropdown from '../../directives/bootstrap/dropdown'

import SortItem from '@ajax/vue/components/molecules/sort/SortItem.vue'

@Component({
  directives: {
    dropdown: BootstrapDropdown,
  },
  components: {
    SortItem,
  },
})
export default class Sort extends Vue {
  static readonly DEFALUT_SORT_KIND = 'new'
  static readonly KEYWORD_MATCH_SORT_KIND = 'keyword_match'

  @Prop({ default: false })
  hasKeywordSearch: boolean

  queries: ItemlistUrlQueryParameter = {}
  open: boolean = false

  mounted() {
    this.queries = Util.convertItemlistUrlParamsToAssociativeArray()
  }

  get formValues() {
    return Object.entries(this.queries).map(([key, value]) => ({ key, value }))
  }

  get actionUrl(): string {
    return this.$route.path
  }

  isChecked(kind: string): boolean {
    return this.currentSortKind === kind
  }

  // 選択肢として提示している並び順。「キーワードマッチ順」はキーワード検索時のみ。
  get availableSortKinds(): string[] {
    const kinds = [Sort.DEFALUT_SORT_KIND, 'popular', 'price']

    return this.hasKeywordSearch ? [Sort.KEYWORD_MATCH_SORT_KIND, ...kinds] : kinds
  }

  // URL の sort が選択肢に無い値（未知の sort 等）のときはデフォルトに倒す。
  // サーバは未知の sort をデフォルト並び順で解決するため、checked 状態を実際の並び順と揃える。
  get currentSortKind(): string {
    const sort = this.queries.sort

    return sort && this.availableSortKinds.includes(sort) ? sort : this.defaultSortKind
  }

  get defaultSortKind(): string {
    return this.hasKeywordSearch ? Sort.KEYWORD_MATCH_SORT_KIND : Sort.DEFALUT_SORT_KIND
  }

  toggle() {
    this.open = !this.open
  }

  get state(): string {
    return this.open ? 'fa-chevron-up' : 'fa-chevron-down'
  }

  sortByKeywordMatch() {
    this.$delete(this.queries, 'sort')
    this.submit()
  }

  sort(value: string) {
    this.$set(this.queries, 'sort', value)
    this.submit()
  }

  submit() {
    this.$nextTick(() => {
      $('.form-sort').submit()
    })
  }
}
